import { Pipe, PipeTransform } from '@angular/core';
import { FormatService } from '../../_core/_services/format';

@Pipe({
  name: 'smartAmount',
  standalone: false
})
export class SmartAmountPipe implements PipeTransform {
  constructor(private format: FormatService) {}

  transform(value: number | string | null | undefined, symbol?: string | null): string {
    return symbol
      ? this.format.smartCurrencyAmount(value, symbol)
      : this.format.smartAmount(value);
  }
}
